import React from "react";

import { Typography } from "antd";

import { NoSearchResultsIcon } from "shared/icons";

import { Container } from "./styled";

const { Text } = Typography;

const PLACEHOLDER_TYPES = {
  search: "SEARCH",
  noData: "NO_DATA",
};

export interface PlaceholderProps {
  type: string;
  label: string;
  Icon?: any;
  /** When set, replaces the default "No {label} Here" copy. */
  message?: string;
}

const Placeholder = ({ type, label, Icon, message }: PlaceholderProps) => (
  <Container data-testid="placeholder">
    {type === PLACEHOLDER_TYPES.search && (
      <NoSearchResultsIcon data-testid="no-search-results-icon" />
    )}
    {type === PLACEHOLDER_TYPES.noData && <Icon data-testid="no-data-icon" />}
    <Text style={{ marginLeft: "16px" }} type="secondary">
      {type === PLACEHOLDER_TYPES.search
        ? "No Search Results"
        : (message ?? `No ${label} Here`)}
    </Text>
  </Container>
);

Placeholder.TYPES = PLACEHOLDER_TYPES;

export default Placeholder;
